export default function permissionService($sbExternalService) {
    "ngInject";

    const service = $sbExternalService?.permissionService?.();
    if (!service) {
        throw new Error(
            "PermissionService is not available in the current environment"
        );
    }

    return service;
}
